module.exports = __webpack_public_path__ + "img/ic_ticket.e4788704.svg";